import React, { Component } from 'react';

import '../css/promo.css'

import promo1 from '../img/foto-cuerpo.jpg'

class Promo extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="row">
          <div className="col">
            <img className="img-fluid" src={promo1} alt=""/>
          </div>
        </div>
      </div>
    )
  }
}

export default Promo;
